import { initializeApp } from "firebase/app";
import { getStorage, ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import { getFirestore, collection, addDoc,setDoc,doc, getDoc ,getDocs,query, where,deleteDoc,updateDoc,writeBatch,orderBy,limit,startAt    } from "firebase/firestore";

// Konfigurasi Firebase
const firebaseConfig = {
  apiKey: "AIzaSyAiWycK0hIpzVy5w-gCdK2tfpQY9VVdWEc",
  authDomain: "hsprojectschool.firebaseapp.com",
  projectId: "hsprojectschool",
  storageBucket: "hsprojectschool.appspot.com",
  messagingSenderId: "1091596013315",
  appId: "1:1091596013315:web:c6011a35b82547ab75a336",
  measurementId: "G-SPBN3DPXVJ",
};

// Inisialisasi Firebase
const app = initializeApp(firebaseConfig);

// Inisialisasi Firestore
const db = getFirestore(app);

// Inisialisasi Storage
const storage = getStorage(app);

// Ekspor instance yang diperlukan
export { db, storage, ref, uploadBytesResumable, getDownloadURL, deleteObject, collection, addDoc , setDoc,doc, getDoc,getDocs,query, where,deleteDoc,updateDoc,writeBatch,startAt,orderBy,limit   };
